// This controls the entire pagination set for the entire frontend application
// content, analytics, subscribers list, etc
// Change this and you change how much we ask per page for all systems.
export const NORMAL_RESULT_LIMIT = 20;
